import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { useLoadItems } from './BskyLoader';
import { forwardRef } from 'react';
import { useSearchParams } from 'react-router';

import Gallery from './Gallery';
import BskyProfile from './BskyProfile';
import FullscreenImage from './FullscreenImage';


function App() {

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const setFullscreenImage = (image) => {
    console.log("Setting fullscreen image:", image);
    setSelectedImage(image);
    setIsFullscreen(true);
  }


  return (
    //change to column for mobile devices

    <div>

      <FullscreenImage imageObject={selectedImage} enabled={isFullscreen} setIsFullscreen={setIsFullscreen} />

    <div className='flex-home-container'>

    
      <div className='flex-sidebar'>

        <div className='sidebar-content'>


        <div className='sidebar-text'>
        <BskyProfile />
        </div>
        

        <div className='sidebar-footer'>
         
          
          <p>Created by <a href="https://yernemm.xyz" target="_blank" rel="noopener noreferrer">Yernemm</a></p>
          
        </div>

        </div>

        </div>
        <div className='flex-gallery'>
          <Gallery setFullscreenImage={setFullscreenImage} />
        </div>

    </div>

    </div>
   
  );
}

export default App;
